import { IconButton, styled } from '@material-ui/core';
import { SRoundedContainer } from '../../../sui/srounded-container';

export const MetricCardsContainer = styled('div')({
  display: 'grid',
  gridAutoFlow: 'column',
  gridAutoColumns: '1fr',
  gap: '16px'
});

export const MetricCardWrapper = styled(SRoundedContainer)({
  borderRadius: '20px',
  width: '100%',
  display: 'flex',
  flexDirection: 'column',
  gap: '8px'
});

export const MetricIconButton = styled(IconButton)({
  pointerEvents: 'none',
  backgroundColor: '#F8F9FA',
  border: '1px solid #EEF0F2',
  padding: '8px',
  '& svg': {
    width: '22px',
    height: '22px'
  }
});

export const MetricValueWrapper = styled('div')({
  display: 'flex',
  columnGap: '6px',
  alignItems: 'flex-end',
  flexWrap: 'wrap',
  padding: '0 8px'
});
